<template>
  <div class="row">
    <div class="col col-12 image-containder" v-if="publicUrl" v-on:click="openPrompImage()">
      {{dimention.height}} x {{dimention.width}} px
      <img class="preview-image" :src="publicUrl"/>
    </div>
    <div class="col col-12">
      <input class="form-control" readonly :value="value">
    </div>
    <div class="col-md-2 mt-1">
      <div class="btn-group">
        <DownloadS3File
          :path="value"
          :name="param+'.png'"
          :force="'si'"
          style-class="btn btn-outline-secondary"
          v-b-tooltip="'Descargar'"
        >
          <template slot="body" slot-scope="props">
            <span class="material-icons" v-if="!props.downloading">cloud_download</span>
            <b-spinner
              v-if="props.downloading"
              variant="primary"
              size="18"
            />
          </template>
        </DownloadS3File>
        <UploadFileToS3
          @input="uploadLocalFile"
          :upload-to="attachmentUrl"
          v-b-tooltip="'Cargar'"
          v-if="hasPermisionSave"
        >
          <template slot="button" slot-scope="props">
            <button
              class="btn btn-outline-secondary"
              :disabled="props.progress.enabled"
            >
              <span class="material-icons">cloud_upload</span>
            </button>
          </template>
        </UploadFileToS3>
      </div>
    </div>
    <vs-prompt
      accept-text="Modificar imagen"
      cancel-text="Me arrepentí"
      title="Nueva imagen"
      :is-valid="validarImagenVacia"
      @accept="uploadImagen"
      @close="closePromptImage"
      :active.sync="promtpImage"
      id="prompt-image"
    >
      <div class="cropper-image-container">
        <cropper
          classname="cropper"
          :src="previewImageCroper"
          :stencilProps="{previewClassname: 'preview'}"
          :stencilComponent="$options.components.CircleStencil"
          ref="cropper"
        />
        <div class="button-wrapper">
          <span
            class="button-imagen vs-button-primary vs-button-border"
            @click="$refs.imagen.click()"
          >
            <input type="file" ref="imagen" @change="selectNewImagen($event)" accept="image/*">
            Seleccionar imagen
          </span>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import { v4 as uuidv4 } from 'uuid';
import { mapGetters } from 'vuex';
import { Cropper } from 'vue-advanced-cropper';

import DownloadS3File from '@/febos/global/empresas/componentes/configs/inputs/DownloadS3File';
import UploadFileToS3 from '@/febos/global/empresas/componentes/configs/inputs/UploadFileToS3';
import {
  ioDownloadPrivateFile,
  ioGetPrivateUploadUrl,
  ioUploadFileToPrivateUrl
} from '@/febos/servicios/api/herramientas.api';
import InputConfigMixin from '@/febos/global/empresas/componentes/configs/inputs/InputConfigMixin';

export default {
  name: 'ConfigInputS3File',
  mixins: [InputConfigMixin],
  components: {
    UploadFileToS3, DownloadS3File, Cropper
  },
  data: () => ({
    promtpImage: false,
    viewHtml: false,
    publicUrl: '',
    previewImageCroper: '',
    progress: {
      enabled: false,
      percent: 0,
      indeterminate: true
    },
    progressImage: {
      enabled: false,
      percent: 0,
      indeterminate: true
    },
    dimention: {
      width: 0,
      height: 0
    }
  }),
  computed: {
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    validarImagenVacia() {
      return this.previewImageCroper !== '';
    }
  },
  mounted() {
    this.valueMutable = this.value;
    this.loadImageUrl();
  },
  watch: {
    publicUrl(val) {
      if (val) {
        const img = new Image();
        img.onload = () => {
          console.log(`the image dimensions are ${img.width}x${img.height}`);
          this.dimention.width = img.width;
          this.dimention.height = img.height;
        };
        img.src = val;
      }
    }
  },
  methods: {
    transformaImagenFile(url, filename, mimeTypeParam) {
      const mimeType = mimeTypeParam || (url.match(/^data:([^;]+);/) || '')[1];
      return (fetch(url)
        .then((res) => res.arrayBuffer())
        .then((buf) => new File([buf], filename, { type: mimeType }))
      );
    },
    uploadImagen() {
      const { coordinates, canvas } = this.$refs.cropper.getResult();
      this.coordenadasImagen = coordinates;
      const imagenPreviaCropper = canvas.toDataURL();
      const filename = `${uuidv4() }.png`;
      this.transformaImagenFile(imagenPreviaCropper, filename)
        .then((imagen) => {
          this.$vs.notify({
            title: 'Su imagen se esta subiendo.',
            text: 'En breves instantes se actualizara tu imagen..',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          });
          const url = `${this.attachmentUrl}/${filename}`;
          this.progressImage.percent = 0;
          this.progressImage.enabled = true;
          ioGetPrivateUploadUrl(url, imagen.type)
            .then((response) => {
              ioUploadFileToPrivateUrl(
                response.data?.url,
                imagen,
                (percent) => {
                  this.progressImage.percent = percent;
                }
              ).then(() => {
                this.uploadLocalFile({ path: url });
              });
            });
        })
        .catch((err) => {
          console.error('Error: ', err);
        });
    },
    openPrompImage() {
      this.promtpImage = true;
      this.previewImageCroper = this.publicUrl;
    },
    closePromptImage() {
      this.promtpImage = true;
    },
    selectNewImagen(event) {
      const input = event.target;
      if (input.files && input.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          console.log(e.target.result);
          this.previewImageCroper = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    async loadImageUrl() {
      if (this.valueMutable) {
        const response = await ioDownloadPrivateFile({
          path: this.valueMutable
        });
        this.publicUrl = response.data.url;
      }
    },
    async uploadLocalFile({ path }) {
      this.$emit('input', path);
      const response = await ioDownloadPrivateFile({
        path
      });
      this.publicUrl = response.data.url;
    }
  },
  props: {
    value: {
      type: String,
      required: false,
    },
    param: {
      type: String,
      required: false,
    },
    level: {
      type: String,
      required: false,
    }
  }
};
</script>

<style scoped lang="scss">
.preview-image {
  max-height: 500px;
  max-width: 500px;
  overflow: auto;
  border: 1px black solid;
  padding: 10px;
  border-radius: 5px;
  margin: auto;
  margin-bottom: 20px;
  background-color: rgba(128, 128, 128, 0.01);
}
.image-containder{
  text-align: center;
}

.cropper {
  height: 60vh;
  width: 60vw;
  background: #DDD;
}

.cropper::v-deep .vue-advanced-cropper__background {
  background: white !important;
}

.button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 17px;
}

.button-imagen {
  border-radius: 6px;
  font-size: 14px;
  padding: 10px 20px;
  cursor: pointer;
  transition: background 0.5s;
}

.button-imagen input {
  display: none;
}

</style>
